import { createStore } from 'vuex';
import { LockDesignerAdminSearch, LockDesignerAdminUpdate } from "Api/apis";
import {
	LockDesignerAdminAsset,
	LockDesignerAdminSearchRequest,
	LockDesignerAdminUpdateRequest,
	LockDesignerAdminUpdateResponse, LockDesignerAssetType
} from "Vue/interfaces/LockDesignerAdminTool";
import { useToast } from 'vue-toastification';
import { ref } from "vue";

const toast = useToast();
const AssetTypes = {
	Knob: "Knob",
	Door: "Door",
	Lever: "Lever",
	//HANDLESETS
	Handleset: "Handleset",
	KeyedKnob: "KeyedKnob",
	KeyedLever: "KeyedLever",

	HandlesetGripWithKnob: "HandlesetGripWithKnob",
	HandlesetGripWithLever: "HandlesetGripWithLever",

	ElectronicsGripMinusKnobLever: "ElectronicsGripMinusKnobLever",
	HandlesetGripMinusKnobLever: "HandlesetGripMinusKnobLever",
	SectionalTrimMinusKnobLever: "SectionalTrimMinusKnobLever",

	MortiseExteriorTrim: "MortiseExteriorTrim",

	//ESCUTCHEONS
	Escutcheon: "Escutcheon",
	StandardRose: "StandardRose",
	SmallBoreRose: "SmallBoreRose",
	NineInchRose: "NineInchRose",
	LargeRose: "LargeRose",
	FiveEighthRose: "FiveEighthRose",
	LargeEscutcheonSmallBoreRose: "LargeEscutcheonSmallBoreRose",
	//DEADBOLTS
	Deadbolt: "Deadbolt",
	MechanicalDeadbolt: "MechanicalDeadbolt",
	KeypadDeadbolt: "KeypadDeadbolt",
	TouchscreenDeadbolt: "TouchscreenDeadbolt",
	//TURNKNOBS
	TurnKnob: "TurnKnob",
	BoltTurnPiece: "BoltTurnPiece",
	TurnPieceSet: "TurnPieceSet",
	PrivacyBolt: "PrivacyBolt",
	MortiseCylinder: "MortiseCylinder",
	//BACKPLATES
	Backplate: "Backplate",
	Latch: "Latch"
};

export const LockDesignerAdminToolStore: any = createStore({
	state: {
		assetTypes: [], // Initialize your state
		currentlySelectedAssetType: "Door",
		responseData: {},
		searchTerm: "",
		compiledImageUrl: "",
		inside: false,
		mode: "outside",
		isLoading: false,
		activeImageAsset: {} as LockDesignerAdminAsset,
		activeAsset: {} as LockDesignerAdminAsset,
		hideLoadingMessage: false,
		removeParams: false,
		isLoadingMessage: "",
		urlActivelyCompiling: false,
		doorEdge: "",
		handle: {
			id: undefined,
			error: undefined,
			errorMessage: undefined
		},
		escutcheon: {
			id: undefined,
			error: undefined,
			errorMessage: undefined
		},
		deadbolt: {
			id: undefined,
			error: undefined,
			errorMessage: undefined
		},
		turnKnob: {
			id: undefined,
			error: undefined,
			errorMessage: undefined
		},
		door: {
			id: undefined,
			error: undefined,
			errorMessage: undefined
		},
		knob: {
			id: undefined,
			error: undefined,
			errorMessage: undefined
		},
		lever: {
			id: undefined,
			error: undefined,
			errorMessage: undefined
		},
		handleset: {
			id: undefined,
			error: undefined,
			errorMessage: undefined
		},
		backplate: {
			id: undefined,
			error: undefined,
			errorMessage: undefined
		},
		latch: {
			id: undefined,
			error: undefined,
			errorMessage: undefined
		},
	},
	mutations: {
		setAssetTypes(state, assetTypes) {
			state.assetTypes = assetTypes;
		},
		setCurrentlySelectedAssetType(state, assetType) {
			state.currentlySelectedAssetType = assetType;
		},
		setResponseData(state, responseData) {
			state.responseData = responseData;
		},
		setHideLoadingMessage(state, value) {
			state.hideLoadingMessage = value
		},
		setIsLoading(state, value) {
			state.isLoading = value;
		},
		setActiveImageAsset(state, value) {
			state.activeImageAsset = value;
		},
		setActiveAsset(state, value) {
			state.activeAsset = value;
		},
		setMode(state, value) {
			state.mode = value;
		},
		setIsLoadingMessage(state, value) {
			state.isLoadingMessage = value;
		},
		setSearchTerm(state, term) {
			state.searchTerm = term;
		},
		setInside(state, inside) {
			state.inside = inside;
		},
		setDoor(state, value) {
			state.door = { ...state.door, ...value };
		},
		setDoorError(state, value) {
			state.door.error = value
		},
		setDoorErrorMessage(state, value) {
			state.door.errorMessage = value
		},
		setHandleset(state, value) {
			state.handleset = { ...state.handleset, ...value };
		},
		setHandlesetError(state, value) {
			state.handleset.error = value
		},
		setHandlesetErrorMessage(state, value) {
			state.handleset.errorMessage = value
		},
		setHandle(state, value) {
			state.handle = { ...state.handle, ...value };
		},
		setHandleError(state, value) {
			state.handle.error = value
		},
		setHandleErrorMessage(state, value) {
			state.handle.errorMessage = value
		},
		setEscutcheon(state, value) {
			state.escutcheon = { ...state.escutcheon, ...value };
		},
		setEscutcheonError(state, value) {
			state.escutcheon.error = value
		},
		setEscutcheonErrorMessage(state, value) {
			state.escutcheon.errorMessage = value
		},
		setDeadbolt(state, value) {
			state.deadbolt = { ...state.deadbolt, ...value };
		},
		setDeadboltError(state, value) {
			state.deadbolt.error = value
		},
		setDeadboltErrorMessage(state, value) {
			state.deadbolt.errorMessage = value
		},
		setKnob(state, value) {
			state.knob = { ...state.knob, ...value };
		},
		setKnobError(state, value) {
			state.knob.error = value
		},
		setKnobErrorMessage(state, value) {
			state.knob.errorMessage = value
		},
		setLever(state, value) {
			state.lever = { ...state.lever, ...value };
		},
		setLeverError(state, value) {
			state.lever.error = value
		},
		setLeverErrorMessage(state, value) {
			state.lever.errorMessage = value
		},
		setTurnKnob(state, value) {
			state.turnKnob = { ...state.turnKnob, ...value };
		},
		setTurnKnobError(state, value) {
			state.turnKnob.error = value
		},
		setTurnKnobErrorMessage(state, value) {
			state.turnKnob.errorMessage = value
		},
		setBackplate(state, value) {
			state.backplate = { ...state.backplate, ...value };
		},
		setBackplateError(state, value) {
			state.backplate.error = value
		},
		setBackplateErrorMessage(state, value) {
			state.backplate.errorMessage = value
		},
		setLatch(state, value) {
			state.latch = { ...state.latch, ...value };
		},
		setLatchError(state, value) {
			state.latch.error = value
		},
		setLatchErrorMessage(state, value) {
			state.latch.errorMessage = value
		},
		setCompiledImageUrl(state, value) {
			state.compiledImageUrl = value
		},
		setRemoveParams(state, value) {
			state.removeParams = value;
		},
		setUrlActivelyCompiling(state, value) {
			state.urlActivelyCompiling = value;
		}
	},
	actions: {
		async getAssets({ commit }, { passedAssetType = "Door", searchInside = false, searchTerm = '', excludeModified = false, filterOptions = { pageNumber: 1, resultsPerPage: 20 } }) {
			const lockDesignerAdminSearchRequest = new LockDesignerAdminSearchRequest(
				//@ts-ignore
				passedAssetType,
				searchTerm,
				excludeModified,
				filterOptions
			);
			lockDesignerAdminSearchRequest.inside = searchInside;

			// Call REST API
			const lockDesignerAdminSearchResponse = await LockDesignerAdminSearch(lockDesignerAdminSearchRequest);

			// Commit the response to the Vuex store
			commit('setResponseData', lockDesignerAdminSearchResponse);
		},

		async updateAssets({ commit, dispatch, state }, { handle = {}, escutcheon = {}, deadbolt = {}, turnKnob = {}, backplate = {}, latch = {} }) {
			commit('setIsLoading', true);
			commit('setIsLoadingMessage', `Saving Selections`);

			const hasError = () => {
				const errorKeys = ['escutcheon', 'handle', 'deadbolt', 'turnKnob', 'door', 'knob', 'lever', 'backplate', 'latch'];
				return errorKeys.some((key) => state?.[key]?.error === true);
			};

			//set request data
			const lockDesignerAdminUpdateRequest: LockDesignerAdminUpdateRequest = {
				handle: handle,
				escutcheon: escutcheon,
				privacyBolt: turnKnob?.id ? turnKnob : deadbolt, //turnknob wins if both provided
				backplate: backplate,
				latch: latch,
			};

			if (turnKnob?.id && deadbolt?.id) {
				toast.info(`Note: You have both a Turn Knob and Deadbolt specified. In this scenario only the Turn Knob data will be saved. If you want Deadbolt info to be saved remove the Turn Knob and save again`, {
					timeout: 12000,
				});
			}

			// Call REST API
			const lockDesignerAdminUpdateResponse: LockDesignerAdminUpdateResponse = await LockDesignerAdminUpdate(
				lockDesignerAdminUpdateRequest
			);

			commit('setHandleError', lockDesignerAdminUpdateResponse.handleResults?.isError ?? false);
			commit('setHandleErrorMessage', lockDesignerAdminUpdateResponse.handleResults?.messages ?? []);

			commit('setEscutcheonError', lockDesignerAdminUpdateResponse.escutcheonResults?.isError ?? false);
			commit('setEscutcheonErrorMessage', lockDesignerAdminUpdateResponse.escutcheonResults?.messages ?? []);

			commit('setDeadboltError', lockDesignerAdminUpdateResponse.deadboltResults?.isError ?? false);
			commit('setDeadboltErrorMessage', lockDesignerAdminUpdateResponse.deadboltResults?.messages ?? []);

			commit('setTurnKnobError', lockDesignerAdminUpdateResponse.turnKnobResults?.isError ?? false);
			commit('setTurnKnobErrorMessage', lockDesignerAdminUpdateResponse.turnKnobResults?.messages ?? []);

			commit('setBackplateError', lockDesignerAdminUpdateResponse.backplateResults?.isError ?? false);
			commit('setBackplateErrorMessage', lockDesignerAdminUpdateResponse.backplateResults?.messages ?? []);

			commit('setHandlesetError', lockDesignerAdminUpdateResponse.handlesetResults?.isError ?? false);
			commit('setHandlesetErrorMessage', lockDesignerAdminUpdateResponse.handlesetResults?.messages ?? []);

			commit('setLatchError', lockDesignerAdminUpdateResponse.latchResults?.isError ?? false);
			commit('setLatchErrorMessage', lockDesignerAdminUpdateResponse.latchResults?.messages ?? []);

			//get results again so it updates
			await dispatch('getAssets', {
				passedAssetType: state.currentlySelectedAssetType,
				searchInside: state?.inside,
				searchTerm: state?.searchTerm,
				excludeModified: false,
				filterOptions: {
					pageNumber: 1,
					resultsPerPage: 500
				}
			});

			if (hasError()) {
				commit('setIsLoading', false)
				toast.error(`An Error Occurred and We Could not Save Your Selections`, {
					timeout: 3000,
				});
			} else {
				commit('setIsLoading', false)
				toast.success(`Successfully Saved Items`, {
					timeout: 3000,
				});
			}

			commit('setIsLoading', false)
		},

		/* SETS THE RETURN URL STRUCTURE*/
		async returnUrlStructure({ commit, dispatch, state }, asset) {
			commit('setUrlActivelyCompiling', true);
			let updateOrAddQueryParam = (url: string, paramsToUpdate) => {
				const urlObject = new URL(url);
				const searchParams = urlObject.searchParams;

				// Remove specified parameters if shouldRemove is true
				if (state.removeParams) {
					// Remove parameters listed in paramsToUpdate
					for (const paramName in paramsToUpdate) {
						searchParams.delete(paramName);
					}
				} else {
					// Iterate over the keys in the object
					for (const paramName in paramsToUpdate) {
						// Check if the parameter already exists
						if (searchParams.has(paramName)) {
							// If it exists, update the parameter value
							searchParams.set(paramName, paramsToUpdate[paramName]);
						} else {
							// If it doesn't exist, add the parameter
							searchParams.append(paramName, paramsToUpdate[paramName]);
						}
					}
				}

				let urlObjectPreConvert = urlObject.toString();
				return urlObjectPreConvert.replace(/\%24/g, "$");

			}

			// Mapping of asset types to their corresponding parameters
			const assetTypeMappings = {
				[AssetTypes.Knob]: { paramPrefix: "$handle", hideParam: "$handleHide" },
				[AssetTypes.Lever]: { paramPrefix: "$handle", hideParam: "$handleHide" },
				[AssetTypes.Handleset]: { paramPrefix: "$handle", hideParam: "$handleHide" },
				[AssetTypes.KeyedKnob]: { paramPrefix: "$handle", hideParam: "$handleHide" },
				[AssetTypes.HandlesetGripWithKnob]: { paramPrefix: "$handle", hideParam: "$handleHide" },
				[AssetTypes.HandlesetGripWithLever]: { paramPrefix: "$handle", hideParam: "$handleHide" },
				[AssetTypes.KeyedLever]: { paramPrefix: "$handle", hideParam: "$handleHide" },
				[AssetTypes.HandlesetGripMinusKnobLever]: { paramPrefix: "$handle", hideParam: "$handleHide" },
				[AssetTypes.SectionalTrimMinusKnobLever]: { paramPrefix: "$handle", hideParam: "$handleHide" },
				[AssetTypes.ElectronicsGripMinusKnobLever]: { paramPrefix: "$handle", hideParam: "$handleHide" },
				[AssetTypes.MortiseExteriorTrim]: { paramPrefix: "$handle", hideParam: "$handleHide" },
				[AssetTypes.Escutcheon]: { paramPrefix: "$escutcheon", hideParam: "$escutcheonHide" },
				[AssetTypes.StandardRose]: { paramPrefix: "$escutcheon", hideParam: "$escutcheonHide" },
				[AssetTypes.SmallBoreRose]: { paramPrefix: "$escutcheon", hideParam: "$escutcheonHide" },
				[AssetTypes.NineInchRose]: { paramPrefix: "$escutcheon", hideParam: "$escutcheonHide" },
				[AssetTypes.LargeRose]: { paramPrefix: "$escutcheon", hideParam: "$escutcheonHide" },
				[AssetTypes.FiveEighthRose]: { paramPrefix: "$escutcheon", hideParam: "$escutcheonHide" },
				[AssetTypes.LargeEscutcheonSmallBoreRose]: { paramPrefix: "$escutcheon", hideParam: "$escutcheonHide" },
				[AssetTypes.Deadbolt]: { paramPrefix: "$deadbolt", hideParam: "$deadboltHide" },
				[AssetTypes.MechanicalDeadbolt]: { paramPrefix: "$deadbolt", hideParam: "$deadboltHide" },
				[AssetTypes.KeypadDeadbolt]: { paramPrefix: "$deadbolt", hideParam: "$deadboltHide" },
				[AssetTypes.TouchscreenDeadbolt]: { paramPrefix: "$deadbolt", hideParam: "$deadboltHide" },
				[AssetTypes.Deadbolt]: { paramPrefix: "$deadbolt", hideParam: "$deadboltHide" },
				[AssetTypes.BoltTurnPiece]: { paramPrefix: "$tpKnob", hideParam: "$tpKnobHide" },
				[AssetTypes.TurnKnob]: { paramPrefix: "$tpKnob", hideParam: "$tpKnobHide" },
				[AssetTypes.TurnPieceSet]: { paramPrefix: "$tpKnob", hideParam: "$tpKnobHide" },
				[AssetTypes.MortiseCylinder]: { paramPrefix: "$tpKnob", hideParam: "$tpKnobHide" },
				[AssetTypes.Backplate]: { paramPrefix: "$tpBackplate", hideParam: "$tpBackplateHide" },
				[AssetTypes.Door]: { paramPrefix: "$bg", hideParam: "$bgHide" },
				[AssetTypes.Latch]: { paramPrefix: "$latch", hideParam: "$latchHide" },
			};

			// Get the asset type
			const assetType = asset.assetType;

			// Check if the asset type exists in the mapping
			if (assetTypeMappings.hasOwnProperty(assetType)) {
				// Retrieve parameters based on the asset type
				const { paramPrefix, hideParam } = assetTypeMappings[assetType];
				let paramsToUpdate = {};
				let paramsToUpdateInside = {};
				// Define parameters to update
				if (assetType === AssetTypes.Door) {
					paramsToUpdate = {
						[paramPrefix]: `Baldwin/${state.activeImageAsset?.scene7Id}`,
						[`${paramPrefix}S`]: `2800, 2000`,
						[hideParam]: 0,
					};
					paramsToUpdateInside = {
						[paramPrefix]: `Baldwin/${state.activeImageAsset?.scene7Id}`,
						[`${paramPrefix}S`]: `2800, 2000`,
						[hideParam]: 0,
					};
				} else {
					paramsToUpdate = {
						[`${paramPrefix}P`]: `${asset.x},${asset.y}`,
						[`${paramPrefix}S`]: `${asset.width},0`,
						[paramPrefix]: `Baldwin/${asset.scene7IdOutside}`,
						[hideParam]: 0,
					};
					paramsToUpdateInside = {
						[`${paramPrefix}P`]: paramPrefix === "latch" ? `${asset.x},${asset.y}` : `${asset.altX},${asset.altY}`,
						[`${paramPrefix}S`]: paramPrefix === "latch" || asset.geometry === "MortisePosition" ? `${asset.width},0` : `${asset.altWidth},0`,
						[paramPrefix]: `Baldwin/${asset.scene7IdInside}`,
						[hideParam]: 0,
					};
				}

				// Update or add parameters to the compiled image URL in the Vuex store
				commit('setCompiledImageUrl', updateOrAddQueryParam(state.compiledImageUrl, state?.mode === 'outside' ? paramsToUpdate : paramsToUpdateInside));
			}

			setTimeout(() => {
				commit('setUrlActivelyCompiling', false);
			}, 800);
		},

		async unsetAsset({ commit, dispatch, state }, { assetType, storeProp }) {
			commit('setRemoveParams', true);
			class LockDesignerUpdate extends LockDesignerAdminAsset {
				constructor(assetType) {
					super();
					super.assetType = assetType; // Set the 'assetType' property
				}

				error = ref(false);
				errorMessage = ref<string[]>([]);
			}

			commit(`set${assetType}`, new LockDesignerUpdate(assetType));

			//commit(`set${assetType}`, { id: undefined, error: undefined, errorMessage: undefined });
			await dispatch('returnUrlStructure', state[storeProp]);
			commit('setRemoveParams', false);
		},

		async setAsset({ commit, dispatch, state }, asset) {
			commit('setMode', 'outside');

			const getConsolidatedCommitString = (assetType) => {
				let handlesetCategoryGrouping = [AssetTypes.Handleset, AssetTypes.KeyedKnob, AssetTypes.KeyedLever, AssetTypes.ElectronicsGripMinusKnobLever, AssetTypes.HandlesetGripWithKnob, AssetTypes.HandlesetGripWithLever, AssetTypes.HandlesetGripMinusKnobLever, AssetTypes.SectionalTrimMinusKnobLever, AssetTypes.MortiseExteriorTrim];
				let deadboltCategoryGrouping = [AssetTypes.Deadbolt, AssetTypes.MechanicalDeadbolt, AssetTypes.KeypadDeadbolt, AssetTypes.TouchscreenDeadbolt];
				let escutcheonCategoryGrouping = [AssetTypes.Escutcheon, AssetTypes.StandardRose, AssetTypes.SmallBoreRose, AssetTypes.NineInchRose, AssetTypes.LargeRose, AssetTypes.FiveEighthRose, AssetTypes.LargeEscutcheonSmallBoreRose];
				let turnKnobCategoryGrouping = [AssetTypes.TurnKnob, AssetTypes.BoltTurnPiece, AssetTypes.TurnPieceSet, AssetTypes.PrivacyBolt, AssetTypes.MortiseCylinder];
				if (handlesetCategoryGrouping.includes(assetType)) {
					return 'setHandleset';
				} else if (deadboltCategoryGrouping.includes(assetType)) {
					return 'setDeadbolt';
				} else if (escutcheonCategoryGrouping.includes(assetType)) {
					return 'setEscutcheon';
				} else if (turnKnobCategoryGrouping.includes(assetType)) {
					return 'setTurnKnob';
				} else {
					return `set${assetType}`
				}
			}

			class LockDesignerUpdate extends LockDesignerAdminAsset {
				constructor(assetType: LockDesignerAssetType) {
					super();
					super.assetType = assetType; // Set the 'assetType' property
				}

				error = ref(false);
				errorMessage = ref<string[]>([]);
			}

			let commitString = getConsolidatedCommitString(asset.assetType);
			let handlesetCategoryGrouping = [AssetTypes.Handleset, AssetTypes.KeyedKnob, AssetTypes.KeyedLever, AssetTypes.ElectronicsGripMinusKnobLever, AssetTypes.HandlesetGripMinusKnobLever, AssetTypes.SectionalTrimMinusKnobLever, AssetTypes.HandlesetGripWithKnob, AssetTypes.HandlesetGripWithLever, AssetTypes.MortiseExteriorTrim];

			//if the assetDoesnt exist already in the
			if (asset.assetType === AssetTypes.Knob && (state?.lever?.id || state?.handleset?.id)) {
				commit('setLever', new LockDesignerUpdate(LockDesignerAssetType.Lever));
				commit('setHandleset', new LockDesignerUpdate(LockDesignerAssetType.Handleset));
			} else if (asset.assetType === AssetTypes.Lever && (state?.knob?.id || state?.handleset?.id)) {
				commit('setKnob', new LockDesignerUpdate(LockDesignerAssetType.Knob));
				commit('setHandleset', new LockDesignerUpdate(LockDesignerAssetType.Handleset));
			} else if (handlesetCategoryGrouping.includes(asset.assetType) && (state?.lever?.id || state?.knob?.id)) {
				commit('setKnob', new LockDesignerUpdate(LockDesignerAssetType.Knob));
				commit('setLever', new LockDesignerUpdate(LockDesignerAssetType.Lever));
			} else if (asset.assetType === AssetTypes.Latch && state?.latch?.id) {
				commit('setLatch', new LockDesignerUpdate(LockDesignerAssetType.Latch));
			}



			// Check if the asset is of type Door
			if (asset.assetType === AssetTypes.Door) {
				commit('setActiveImageAsset', asset);
				// Initialize newUrl with the asset's imageUrl property
				let newUrl = "https://images.baldwinhardware.com/is/image/Baldwin/lockdesigner";

				// Check if compiledImageUrl in the store exists
				if (state && state.compiledImageUrl) {
					// Extract the query string part of compiledImageUrl, if it exists
					const remainingUrl = state.compiledImageUrl.includes('?') ? state.compiledImageUrl.split('?')[1] : '';

					// Append the remaining query string to the newUrl, if any
					newUrl = remainingUrl ? `${newUrl}?${remainingUrl}` : newUrl;
				}

				// Set or update compiledImageUrl in the store
				commit('setCompiledImageUrl', newUrl);
			} else {
				commit('setActiveAsset', asset);
			}

			commit(commitString, asset);
			await dispatch('returnUrlStructure', asset);
		},
	},
	getters: {
		// Your getters here
	},
	modules: {
		// Your modules here
	},
});
